import React from 'react';
import PropTypes from 'prop-types';

import Request from "../containers/Request";

import Chip from 'react-toolbox/lib/chip/Chip';
import Button from 'react-toolbox/lib/button/Button';
import ProgressBar from 'react-toolbox/lib/progress_bar/ProgressBar';

import styled from 'styled-components';
import {ScreenCentered, StandaloneForm, ThemedHeader} from '../../Styled';
import GReCaptcha from "../../GReCaptcha";

const StyledLink = styled.a`
    color: rgba(29, 29, 29, .7);
`;

const ContactDetails = styled.div`
    margin: auto;
    max-width: 500px;
    display: grid;
    @media (min-width: 751px) {
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 10px;
    }
    @media (max-width: 750px) {
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }
`;

const Contact = ({isFilled, reCaptchaShow, setReCaptchaResponse, submit, submitWaiting, submitSuccess, submitFailure}) => {
    return (
        <ScreenCentered>
            <ThemedHeader>Contact</ThemedHeader>
            <StandaloneForm style={{marginBottom: "30px"}}>
                <ContactDetails>
                    <Chip><StyledLink href='tel:+18017070508'>801-707-0508 (Brad)</StyledLink></Chip>
                    <Chip><StyledLink href='mailto:brad@paraglideutah.com'>brad@paraglideutah.com</StyledLink></Chip>
                </ContactDetails>
                <Request/>
            </StandaloneForm>
            <span>
                {!reCaptchaShow && !submitWaiting && !submitSuccess && !submitFailure &&
                 <Button icon='email' label='send the message' raised primary disabled={!isFilled} onClick={submit}/>}

                {reCaptchaShow &&
                 <GReCaptcha onResponse={setReCaptchaResponse}/>}

                {submitWaiting &&
                 <ProgressBar type="circular" mode="indeterminate"/>}

                {submitSuccess &&
                 <strong style={{color: 'green'}}>Your message has been sent. Thank you!</strong>}

                {submitFailure &&
                 <strong style={{color: 'red'}}>Something went wrong! Please let us know and try again later.</strong>}
            </span>
        </ScreenCentered>
    )
};

Contact.propTypes = {
    isFilled:      PropTypes.bool.isRequired,
    submit:        PropTypes.func.isRequired,
    submitWaiting: PropTypes.bool.isRequired,
    submitSuccess: PropTypes.bool.isRequired,
    submitFailure: PropTypes.bool.isRequired
};

export default Contact;



// WEBPACK FOOTER //
// ./src/app/contact/components/Contact.js